import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Config, WEB_CONFIG } from '../../config';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { CommonApiService } from '../api/common-api.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AuthUserModel } from '../../models';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private http: HttpClient,
    private cookieService: CookieService,
    private commonApiService: CommonApiService,
    @Inject(WEB_CONFIG) private config: Config
  ) {
  }

  public canActivate(): boolean | Observable<boolean> {
    if (this.cookieService.check('auth-mail')) {
      if (this.commonApiService.isTokenValid()) {
        return true;
      }

      const user: AuthUserModel = this.commonApiService.getUserDataFromToken();
      const email: string = user.secondary ? user.email : this.cookieService.get('auth-mail');

      return this.commonApiService.ssoLogin(email).pipe(
        map((data) => {
          user.secondary ? this.commonApiService.setSecondaryToken(data.token) : this.commonApiService.setToken(data.token);
          return true;
        })
      );
    } else {
      window.location.href = this.config.api_url + '/login/invalid';
      return false;
    }
  }
}
